/* globals $ */
import { React, PT } from '@gasbuddy/react';
import JSONTree from 'react-json-tree';
import { Button, Modal, Form, Header, Icon, Label } from 'semantic-ui-react';
import sift from 'sift';
import featureApi from './featureApi';
import coupon from './coupon';

function initializeQueryBuilder(element, kind) {
  const config = {
    filters: kind.FILTERS,
    optgroups: kind.OPTGROUPS,
    icons: {
      add_group: 'add square icon',
      add_rule: 'add circle icon',
      remove_group: 'minus square icon',
      remove_rule: 'minus circle icon',
      error: 'warning sign icon',
    },
  };
  return $(element).queryBuilder(config);
}

function cleanRules(rules) {
  const tlKeys = rules ? Object.keys(rules) : [];
  if (!tlKeys.includes('$and') && !tlKeys.includes('$or')) {
    return { $and: [rules] };
  }
  return rules;
}

function defaultState({ defaultValue }) {
  return { rules: defaultValue || undefined };
}

export class QueryBuilder extends React.Component {
  static FeatureApi = featureApi;

  static Coupon = coupon;

  state = defaultState(this.props)

  componentWillReceiveProps(nextProps) {
    const { defaultValue } = this.props;
    if (nextProps.defaultValue && !defaultValue) {
      if (this.qb) {
        if (this.setRules(nextProps.defaultValue)) {
          this.setState({ changed: false });
        }
      } else {
        this.createQb(nextProps.defaultValue);
      }
    }
  }

  shouldComponentUpdate() {
    return false;
  }

  componentWillUnmount() {
    if (this.qb) {
      this.qb.destroy();
    }
  }

  onChange = () => {
    this.setState({ changed: true }, this.forceUpdate);
  }

  setRules(rules) {
    try {
      if (rules) {
        this.qb.setRulesFromMongo(cleanRules(rules));
      }
      return true;
    } catch (queryError) {
      this.setState({ queryError });
      return false;
    }
  }

  startTesting = () => {
    const rules = this.qb.getMongo();
    this.setState({ testOpen: true, query: rules }, this.forceUpdate);
  }

  testRule = () => {
    const { query, request } = this.state;
    const match = sift(query, [JSON.parse(request)]);
    this.setState({ wasMatch: match.length === 1 }, this.forceUpdate);
  }

  // get data from jQuery Query Builder and pass to the react component
  saveChanges = () => {
    const rules = this.qb.getMongo();
    const { save } = this.props;
    save(rules);
  }

  createQb(initialRules) {
    const element = this.queryBuilder;
    const { kind } = this.props;
    this.qb = initializeQueryBuilder(element, kind)[0].queryBuilder;
    ['add', 'update', 'move', 'drop'].forEach(e => this.qb.model.on(e, this.onChange));
    if (this.setRules(initialRules)) {
      this.forceUpdate();
    }
  }

  render() {
    const { query = '', queryError, changed, saving, testOpen, request, wasMatch } = this.state;
    const { kind: { REQUESTS } } = this.props;

    if (queryError) {
      return <JSONTree data={query} />;
    }

    return (
      <div>
        <div>
          <div id="query-builder" ref={(qb) => { this.queryBuilder = qb; }} />
          {changed
            && <Button content="Save Changes" loading={saving} onClick={this.saveChanges} />
          }
          {this.qb
            && (
            <Modal
              closeIcon
              closeOnEscape
              open={testOpen}
              onClose={() => this.setState({ testOpen: false }, this.forceUpdate)}
              trigger={<Button content="Test" onClick={this.startTesting} />}
            >
              <Header content="Test Eligibility" />
              <Modal.Content>
                <Form>
                  <JSONTree data={query} />
                  <Form.Dropdown
                    fluid
                    selection
                    label="Client Request"
                    text="Choose a preconfigured request..."
                    options={[
                      { text: 'iOS', value: 0 },
                      { text: 'Android', value: 1 },
                    ]}
                    onChange={(e, { value }) => this.setState({ request: JSON.stringify(REQUESTS[value], null, '\t') }, this.forceUpdate)}
                  />
                  <Form.TextArea
                    name="request"
                    value={request}
                    onChange={(e, { value }) => this.setState({ request: value }, this.forceUpdate)}
                    placeholder="{}"
                  />
                </Form>
              </Modal.Content>
              <Modal.Actions>
                {wasMatch === true
                  && (
                  <Label floated="left" color="green">
                    <Icon name="checkmark" />
Matches
                  </Label>
                  )
                }
                {wasMatch === false
                  && (
                  <Label floated="left" color="red">
                    <Icon name="remove" />
Match Fails
                  </Label>
                  )
                }
                <Button basic color="red" onClick={this.testRule}>
                  <Icon name="play" />
                  {' '}
Test
                </Button>
              </Modal.Actions>
            </Modal>
            )
          }
          {!this.qb
            && <Button onClick={() => this.createQb()}>Add Eligibility Criteria</Button>
          }
        </div>
      </div>
    );
  }
}

QueryBuilder.propTypes = {
  defaultValue: PT.shape({}),
  save: PT.func.isRequired,
  kind: PT.shape({
    FILTERS: PT.object,
    OPTGROUPS: PT.object,
    REQUESTS: PT.object,
  }).isRequired,
};

QueryBuilder.defaultProps = {
  defaultValue: null,
};
